import { a as arabic } from './arabic-DwXD-XQR.js';
import { b as bengali } from './bengali-DG1TnEUC.js';
import { d as devanagari } from './devanagari--cO60dSH.js';
import { g as gujarati } from './gujarati-8uOXGHK3.js';
import { h as hebrew } from './hebrew-DlPX3aBh.js';
import { j as japaneseKana } from './japanese-kana-zPTJLKkb.js';
import { k as kannada } from './kannada-IP2ZlJaf.js';
import { k as khmer } from './khmer-D36SfLOK.js';
import { l as lao } from './lao-DUGFuWbt.js';
import { m as malayalam } from './malayalam-LVTRbDLp.js';
import { m as myanmar } from './myanmar-m02lCo4P.js';
import { t as tamil } from './tamil-gDtq5eS6.js';
import { t as telugu } from './telugu-DRXFXV9b.js';
import { t as thai } from './thai-oTCKeJSJ.js';
import { t as tibetan } from './tibetan-CsBaegcy.js';
import { e as emoji } from './emoji-B65VV6l3.js';

var _arabic = arabic;

var _bengali = bengali;

var _devanagari = devanagari;

var _gujarati = gujarati;

var _hebrew = hebrew;

var _japaneseKana = japaneseKana;

var _kannada = kannada;

var _khmer = khmer;

var _lao = lao;

var _malayalam = malayalam;

var _myanmar = myanmar;

var _tamil = tamil;

var _telugu = telugu;

var _thai = thai;

var _tibetan = tibetan;

var _emoji = emoji;

var patterns = [_emoji.countryFlag, _emoji.keyCap, _emoji.emojiVariation, _arabic.arabic, _bengali.bengali, _devanagari.devanagari, _gujarati.gujarati, _hebrew.hebrew, _japaneseKana.japaneseKana, _kannada.kannada, _khmer.khmer, _lao.lao, _malayalam.malayalam, _myanmar.myanmar, _tamil.tamil, _telugu.telugu, _thai.thai, _tibetan.tibetan, '.'];
var splitter = new RegExp("(".concat(patterns.join('|'), ")"), 'gu');

function splitGraphemes(str) {
  return str.match(splitter) || [];
}

var lib = {
  splitGraphemes: splitGraphemes
};

export { lib as l };
//# sourceMappingURL=index-CQH2gKIH.js.map
